import React, { useState } from 'react';
import { createContext, useContext } from 'react';


const PlanViewAdvanced2LayerSelectedContext = createContext({
    selectedLayerIds:null,
    setSelectedLayerIds:null,
});


function PlanViewAdvanced2LayerSelectedContextProvider(props) {

    const [ selectedLayerIds, setSelectedLayerIds ] = useState([]);

    return (
        <PlanViewAdvanced2LayerSelectedContext.Provider value={{
            selectedLayerIds,
            setSelectedLayerIds,
        }} {...props} />
    );
}


const usePlanViewAdvanced2LayerSelectedContext = () => useContext(PlanViewAdvanced2LayerSelectedContext);


export {
    PlanViewAdvanced2LayerSelectedContextProvider,
    PlanViewAdvanced2LayerSelectedContext,
    usePlanViewAdvanced2LayerSelectedContext
};